export function $functionalityEnabled (storeGetters, flagName) {
    const anyProductLineEnabled = storeGetters['productLines/isMetadataEnabledForAnyProductLine'](flagName);
    const segmentFlagEnabled = storeGetters['auth/hasSegmentFlag'](flagName);

    return anyProductLineEnabled || segmentFlagEnabled;
}

export const EnablementPlugin = {
    install (Vue, opts) {
        Vue.mixin({
            methods: {
                // eslint-disable-next-line internal-rules/no-unused-properties
                $functionalityEnabled (flagName) {
                    return $functionalityEnabled(opts.store.getters, flagName);
                },
            },
        });
    },
};
